import makeStyles from '@material-ui/core/styles/makeStyles'

export const useACHDebitStyle = makeStyles((theme) => ({
  darkTypography: {
    color: theme.palette.secondary.dark,
  },
}))
